import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'routeEndHour' })
export class RouteEndHourPipe implements PipeTransform {
  transform(stationIndexTime: any, pigeonRouteDetails: any) {
    if (
      !stationIndexTime.hasOwnProperty(pigeonRouteDetails.stations.length - 1)
    ) {
      return { hour: '', class: '' };
    }
    let hour = stationIndexTime[pigeonRouteDetails.stations.length - 1];
    let hourClass = '';
    if (hour > 23) {
      hour = hour - 24;
      hourClass = 'hour-warn';
    }
    return { hour: hour + ':00', class: hourClass };
  }
}
